import asinso_logo from '../assets/img/asinso-logo.webp';
import asinso_icon from '../assets/img/icon.jpg';
import asinso_logoTextOnly from '../assets/img/logo-text-only.webp';
import mainIcon from '../assets/img/icon.jpg';
import iconPhone from '../assets/img/icons/ico-phone.svg';
import iconMail from '../assets/img/icons/ico-mail.svg';
import iconCheck from '../assets/img/icons/ico-check.png';
import iconComment from '../assets/img/icons/ico-comment.svg';
//import donateBanner from '../assets/img/donate-banner.png';
import sslCheckout from '../assets/img/ssl-checkout.png';
//import etyel_logo from '../assets/img/topventory-logo.webp'
//import topventory_icon from '../assets/img/topventory-icon.webp'
import etyel_icon from '../assets/img/topventory-one-icon.png'
//import topventory_text_only from '../assets/img/topventory-text-only.webp'
import etyel_text_only from '../assets/img/etyel-erp-text-logo.png'
import etyel_one_logo from '../assets/img/etyel-erp-logo.png'
// import topventory_icon from '../assets/img/wvfavicon.jpg'
// import topventory_text_only from '../assets/img/world-vision-logo-dark.png'

import linkmo_logo from '../assets/img/apps-logo/Linkmo.co-main-logo.webp'
import main_logo from '../assets/img/client/polar-air-logo-light.webp'

import polarair_icon from '../assets/img/polarcare/bear-icon.webp'
import polarair_logo from '../assets/img/polarcare/polar-air-logo-light.webp'

import alsamart_logo from '../assets/img/alsamart/AlsaMart-Logo.png'
import alsamart_tag_logo from '../assets/img/alsamart/AlsaMart-with-Tag-Logo.png'
import alsamart_icon from '../assets/img/alsamart/AlsaMart-Icon.png'

const images = {
    main_logo,
    asinso_logo,
    asinso_logoTextOnly,
    asinso_icon,
    mainIcon,
    iconPhone,
    iconMail,
    iconCheck,
    iconComment,
    //donateBanner,
    sslCheckout,
    //etyel_logo,
    etyel_icon,
    etyel_text_only,
    linkmo_logo,
    polarair_icon,
    polarair_logo,
    alsamart_logo,
    alsamart_tag_logo,
    alsamart_icon,
    etyel_one_logo
}

export default images